export default __webpack_public_path__ + "static/media/instagram.a0f59a22.svg";